<template>
  <div v-if="bannerShow">
    <PhoneGuideDialog v-if="show" @close="childeClose"/>

    <div class="BottomBanner-box" @click.stop="registerFn">
      <div class="BottomBanners">
        <img
          class="BottomBanner-bg"
          :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-bg.png`"
          alt=""
        />
        <div class="BottomBanner-cont">
          <img
            class="BottomBanner-wa"
            :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-wa.png`"
            alt=""
            @click.stop="showDialog"
          />
          <div class="BottomBanner-btnBox">
            <img
              class="BottomBanner-btn "
              :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-btn.png`"
              @click.stop="registerFn"
            />
            <img
              class="BottomBanner-close"
              :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-close.png`"
              @click.stop="close"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {imgPath, ossPath} from "@/utils/constants/constants";
import PhoneGuideDialog from "./PhoneGuideDialog.vue"
import { buryPointUserBehaviorInsertRecord } from "@/services/gjxx";
export default {
  name: "footerBannerShow",
  components: {
    PhoneGuideDialog
  },
  data() {
    return {
      username: '',
      CDN: ossPath,
      imgPath,
      bannerShow: true,
      show: false
    };
  },
  computed: {},
  created() {

  },
  mounted() {

  },
  methods: {
    showDialog() { 
      this.show = true;
      console.log('zhanshi ')
      const obj = {
        oid: "86",
        deed: "3",
        source: "gw",
        level: "0",
        uid: 0,
        ctxid: "",
        url: "",
        refer: "",
      }
     buryPointUserBehaviorInsertRecord(obj)
    },
    registerFn() {
      this.$emit("register")
    },
    close() {
      this.bannerShow = false
      this.$emit("close")
    },
    childeClose() {
      this.show = false
    },
  }
};
</script>


<style lang="scss">
.BottomBanner-box {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0;
}

.BottomBanners {
  position: relative;
  width: 100%;
  height: 60px;
  overflow: hidden;
  cursor: pointer;
}

.BottomBanner-bg {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
}

.BottomBanner-cont {
  position: absolute;
  top: 0;
  height: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  min-width: 1000px;
  max-width: 1100px;
  overflow: hidden;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .BottomBanner-wa {
    height: 80px;
    cursor: pointer;
  }

  .BottomBanner-btn {
    height: 30px;
    cursor: pointer;
  }

  .BottomBanner-btnBox {
    display: flex;
    align-items: center;
  }

  .BottomBanner-close {
    height: 20px;
    cursor: pointer;
    margin-left: 50px;
  }
}
</style>
